import {
    FETCH_NGOS,
    FETCH_NGOS_SUCCESS,
    FETCH_NGOS_FAILED,
    EDIT_NGO
} from "../store/types";

export const INITIAL_STATE = {
    ngos: null,
    loading: false,
    error: {
        flag: false,
        msg: null
    }
}

export const ngoreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_NGOS:
            return {
                ...state,
                loading: true
            };
        case FETCH_NGOS_SUCCESS:
            return {
                ...state,
                ngos: action.payload,
                loading: false,
                error: { flag: false, msg: null }
            };
        case FETCH_NGOS_FAILED:
            return {
                ...state,
                ngos: null,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        case EDIT_NGO:
            return state;
        default:
            return state;
    }
};
